import { instance } from '@app/api/axios';
import { useShowToaster } from '@shared/ui/messages/useToaster';
import { useRequestError } from '@app/api/useRequestError';
import { useDispatch } from 'react-redux';
import { fetchUser, updateUser } from '@app/store/slices/userSlice';
import i18n from '@app/i18n';

export function useProfile() {
  const showToaster = useShowToaster();
  const handleRequestError = useRequestError();
  const dispatch = useDispatch();

  const updateProfile = async (data) => {
    try {
      const res = await instance.post('/settings', data);
      dispatch(updateUser(data));
      i18n.changeLanguage(data.language);
      showToaster('success', res?.data?.message);
      return true;
    } catch (err) {
      return handleRequestError(err);
    }
  };

  const changePassword = async (data) => {
    try {
      const res = await instance.post('/settings/change-password', data);
      showToaster('success', res?.data?.message);
      return true;
    } catch (err) {
      return handleRequestError(err);
    }
  };

  const onboard = async (data) => {
    try {
      const res = await instance.post('/onboarding', data);
      showToaster('success', res?.data?.message);
      dispatch(fetchUser());
      return true;
    } catch (err) {
      return handleRequestError(err);
    }
  };

  return { updateProfile, changePassword, onboard };
}
